import { useEffect } from 'react'
import useSession from '@hooks/useSession'
import {
    formatAdminOption,
    useOrgCollectionForm,
} from '@hooks/useOrgCollectionForm'
import API from '@enums/api'

export default function useController() {
    const session = useSession()!

    const collectionId = window.location.pathname.split('/').pop()

    const form = useOrgCollectionForm({
        onSubmit: async (values) => {
            const response = await fetch(
                `/api/ha/v2/org-collections/${collectionId}`,
                {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${session.accessToken}`,
                    },
                    body: JSON.stringify(values),
                }
            )

            return response
        },
    })

    useEffect(() => {
        async function fetchData() {
            try {
                const res = await API.ha.orgs.getOrgCollection(collectionId!)

                if (!res.ok) {
                    throw new Error('Failed to fetch org collection')
                }

                const result = res.value

                const initialFormData = {
                    name: result.name,
                    orgIds: result.organizations.map(
                        (org: { id: string; name: string }) => {
                            return { id: org.id, label: org.name }
                        }
                    ),
                    orgAdminIds: result.orgUsers.map((orgAdmin) => {
                        console.log('orgAdmin', orgAdmin)
                        return formatAdminOption({
                            id: orgAdmin.user_id,
                            email: orgAdmin.email,
                        })
                    }),
                    orgCollectionAdminIds: result.orgCollectionsUsers.map(
                        (orgCollectionAdmin) => {
                            console.log(
                                'orgCollectionAdmin',
                                orgCollectionAdmin
                            )
                            return formatAdminOption({
                                id: orgCollectionAdmin.user_id,
                                email: orgCollectionAdmin.email,
                            })
                        }
                    ),
                }

                form.setValues(initialFormData)
            } catch (error) {
                console.error('Error fetching org collection:', error)
            }
        }

        fetchData()
    }, [])

    return {
        ...form,
    }
}
